import Vue from 'vue';

export default class ApiHeaders extends Vue {
  id: string;
  key: string;
  acceptVersion: string;

  constructor(options) {
    super(options);
    this.id = options.id;
    this.key = options.key;
    this.acceptVersion = 'v2';
  }

  render() {
    if (this.id && this.key) {
      return {
        'X-PLEASESIGN-ID': this.id,
        'X-PLEASESIGN-KEY': this.key,
        'Accept-Version': 'v2',
      };
    }

    return {
      'Accept-Version': 'v2',
    };
  }
}
